import * as icons from "assets/mobile/icons/sidebar";
import { PATH } from "constants/path";

export const menuItemsSidebar = [
  {
    name: "FaceBook ACV88",
    link: "https://www.facebook.com/cskh.acv188",
    icon: icons.IconFacebook,
    isOpen: true,
    color: "rgb(41, 167, 187)",
  },
  // {
  //   name: "BẢNG XẾP HẠNG",
  //   link: "https://rank.acv88.win/",
  //   icon: icons.IconRank,
  //   isOpen: true,
  //   color: "rgb(41, 167, 187)",
  // },
  // {
  //   name: "Nhập code nhận thưởng",
  //   link: "https://vnacv88.com/nhap-code/",
  //   icon: icons.IconCode,
  //   isOpen: true,
  //   color: "rgb(41, 167, 187)",
  // },
  // {
  //   name: "Thông báo mới nhất",
  //   link: PATH.User.Announcement,
  //   icon: icons.IconNotification,
  //   color: "rgb(41, 167, 187)",
  // },
  {
    name: "Hỗ trợ trực tuyến",
    link: "https://acv188.win/",
    icon: icons.IconContactUs,
    isOpen: true,
    color: "rgb(41, 167, 187)",
  },

  {
    name: "Hotline 24/7",
    link: "",
    icon: icons.IconPhone,
    isOpen: true,
    color: "rgb(41, 167, 187)",
  },
  // {
  //   name: "Giới thiệu bạn bè",
  //   link: "http://ag.acv88.guru/Account/Login",
  //   icon: icons.IconReferral,
  //   isOpen: true,
  //   color: "rgb(41, 167, 187)",
  // },
  {
    name: "Thông báo mới nhất",
    link: PATH.User.Notification,
    icon: icons.IconNotification,
    color: "rgb(41, 167, 187)",
  },
  {
    name: "Đăng ký đại lý",
    link: "/AgentApply",
    icon: icons.AddressCardIcon,
    color: "rgb(41, 167, 187)",
  },
  {
    name: "Hợp tác đại lý",
    link: "https://acv188.com/agent-page/",
    icon: icons.MoneyIcon,
    isOpen: true,
    color: "rgb(41, 167, 187)",
  },
  {
    name: "Telegram channel",
    link: "https://t.me/cskh_acv188",
    icon: icons.IconTelegram,
    isOpen: true,
    color: "rgb(41, 167, 187)",
  },
  // {
  //   name: "Live Bóng Đá",
  //   link: "https://latkeo2.tv/",
  //   icon: icons.IconLive,
  //   isOpen: true,
  //   color: "rgb(41, 167, 187)",
  // },
  // {
  //   name: "Backup link",
  //   link: "",
  //   icon: icons.IconLink,
  //   isOpen: true,
  //   color: "rgb(41, 167, 187)",
  // },
  {
    name: "Phiên bản máy tính",
    link: PATH.Home,
    icon: icons.IconVersionPc,
    color: "rgb(41, 167, 187)",
  },
];
